function landingPage() {
    const wrapper = $('#wrapper');
    if (wrapper.attr('data-landingpage') !== undefined) {
        const img_url = "../../../../modules/oryx/views/img/mapping/" + wrapper.data('landingpage');
        wrapper.css({
            'backgroundImage': 'url(' + img_url + ')',
        });
    }
}
landingPage();